import { DragOverlay } from '@dnd-kit/core';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { memo } from 'react';
import { useDelayUnmount } from '@arc/frontend/util-common';
// eslint-disable-next-line @typescript-eslint/no-shadow
export const Draggable = memo(function Draggable({
  id,
  dropAnimation = true,
  hideDraggable,
  dragOpacity = '0%',
  disabled,
  containerStyle,
  ...props
}) {
  const {
    setNodeRef,
    attributes,
    listeners,
    transition,
    transform,
    isDragging
  } = useSortable({
    id,
    disabled
  });
  const shouldRender = useDelayUnmount(isDragging, 250) && !hideDraggable;

  // Needed to override role="button" which is preventing 'cursor: grab' from working
  attributes.role = 'draggable';
  return <>
			<div ref={setNodeRef} css={containerStyle}
    // Set draggable properties on `style` prop to avoid
    // creating unnecessary intermediate classes
    style={{
      transition,
      transform: CSS.Translate.toString(transform),
      opacity: isDragging ? dragOpacity : '100%',
      cursor: disabled ? 'auto' : 'grab'
    }}>
				{props.children(attributes, listeners, isDragging)}
			</div>
			{shouldRender ? <DragOverlay dropAnimation={dropAnimation ? {
      sideEffects: null
    } : null}>
					{isDragging ? props.children(undefined, undefined, isDragging) : null}
				</DragOverlay> : null}
		</>;
});